import { CSSObjectWithLabel } from 'react-select/dist/declarations/src'
import { BaseColor, Color, ColorShade, themeColor, Theme } from '~theme'
import { Size } from './InputItems.types'

export const themeColors = (appTheme: Theme) => ({
  primary: themeColor(Color.primary)({ theme: appTheme }),
  primary75: themeColor(Color.primary, ColorShade.strongest)({ theme: appTheme }),
  primary50: themeColor(Color.primary, ColorShade.stronger)({ theme: appTheme }),
  primary25: themeColor(Color.primary, ColorShade.softer)({ theme: appTheme }),
  danger: themeColor(Color.danger)({ theme: appTheme }),
  dangerLight: themeColor(Color.danger, ColorShade.softer)({ theme: appTheme }),
  neutral0: themeColor(BaseColor.shade_0)({ theme: appTheme }),
  neutral10: themeColor(BaseColor.shade_10)({ theme: appTheme }),
  neutral20: themeColor(BaseColor.shade_20)({ theme: appTheme }),
  neutral30: themeColor(BaseColor.shade_30)({ theme: appTheme }),
  neutral40: themeColor(BaseColor.shade_40)({ theme: appTheme }),
  neutral50: themeColor(BaseColor.shade_50)({ theme: appTheme }),
  neutral60: themeColor(BaseColor.shade_60)({ theme: appTheme }),
  neutral70: themeColor(BaseColor.shade_70)({ theme: appTheme }),
  neutral80: themeColor(BaseColor.shade_80)({ theme: appTheme }),
  neutral90: themeColor(BaseColor.shade_90)({ theme: appTheme }),
  neutral100: themeColor(BaseColor.shade_100)({ theme: appTheme }),
})

const borderColor = (baseStyles: CSSObjectWithLabel, state: any, appTheme: Theme, isError: boolean) => {
  if (state.isDisabled) {
    return themeColor(BaseColor.shade_30)({ theme: appTheme })
  }

  if (isError) {
    return themeColor(Color.danger)({ theme: appTheme })
  }

  return baseStyles.borderColor
}

const sizePaddings = (size: Size) => {
  switch (size) {
    case 'small':
      return '0 0.2rem'
    case 'large':
      return '0.4rem 0.5rem'
    case 'medium':
    default:
      return '0.3rem 0.3rem'
  }
}

type DesignArgs = { isError?: boolean; size: Size; isDuplicateValue: boolean }

export const styles = (appTheme: Theme, { isError, size, isDuplicateValue }: DesignArgs) => ({
  control: (baseStyles: CSSObjectWithLabel, state: any) => ({
    ...baseStyles,
    padding: sizePaddings(size),
    backgroundColor: state.isDisabled ? themeColor(BaseColor.shade_0)({ theme: appTheme }) : baseStyles.backgroundColor,
    opacity: state.isDisabled ? 0.4 : 1,
    borderColor: borderColor(baseStyles, state, appTheme, isError || false),
  }),
  input: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: isDuplicateValue ? themeColor(Color.danger)({ theme: appTheme }) : baseStyles.color,
  }),
})
